import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import { useMediaQuery } from 'src/lib/use-media-query'
import styles from '../styles.module.scss'

export const TextLandEn = () => {
    const isDesktop = useMediaQuery('(min-width: 1024px)')

    return (
        <HighlightedText
            text="325% BONUS UP TO €5,000  + 400 FREE SPINS"
            highlights={[{ word: '325%' }, { word: '€5,000' }, { word: '400' }]}
            breakAfterWords={isDesktop ? ['BONUS', '€5,000'] : ['€5,000']}
            className={styles.text_land}
        />
    )
}
